import { CircularProgress, LinearProgress } from "@material-ui/core";
import React,{lazy,Suspense } from "react";

const Banner = lazy(() => import("../components/Banner/Banner"));
const CoinsTable = lazy(() => import("../components/CoinsTable"));

const Homepage = () => {

  return (
    <>
     <Suspense fallback={<LinearProgress style={{ backgroundColor: "gold" }} />} >
      <Banner />
      <CoinsTable />
      </Suspense>
    </>
  );
};

export default Homepage;
